<script>
  let {
    assetsPath = '/',
    onAiMounted = () => {},
    onArtboardChange = () => {},
  } = $props();
  import { onMount, untrack } from 'svelte';
  let aiBox;
  let aiBoxWidth = $state(undefined);
  let allArtboards = $state([]);
  let activeArtboard = $state(undefined);
  onMount(() => {
    allArtboards = Array.from(aiBox.querySelectorAll('.g-artboard'));
    onAiMounted();
  });
  $effect(() => {
    if (aiBoxWidth) {
      const currentArtboard = allArtboards.filter((artboard) => {
        const minWidth = parseFloat(artboard.dataset.minWidth);
        const maxWidth = parseFloat(artboard.dataset.maxWidth) || Infinity;
        return minWidth <= aiBoxWidth && maxWidth >= aiBoxWidth;
      })[0];
      if (currentArtboard?.id !== activeArtboard?.id) {
        activeArtboard = untrack(() => currentArtboard);
        onArtboardChange(activeArtboard);
      }
    }
  });
</script>

<div
  id="g-airbagImage-box"
  class="ai2svelte"
  bind:this={aiBox}
  bind:clientWidth={aiBoxWidth}
>
  <!-- Artboard: xs -->
  <div
    id="g-airbagImage-xs"
    class="g-artboard"
    style="max-width: 509px;aspect-ratio: 0.55743243243243;"
    data-aspect-ratio="0.557"
    data-min-width="0"
    data-max-width="509"
  >
    <div
      id="g-airbagImage-xs-img"
      class="g-airbagImage-xs-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/airbagImage-xs.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai0-1"
      class="g-boxtext g-aiAbs"
      style="top:8.277%;left:30.142%;margin-left:-19.0909%;width:38.1818%;"
    >
      <p class="g-pstyle0">Blood on airbag of Good&rsquo;s vehicle</p>
    </div>
    <div
      id="g-ai0-2"
      class="g-boxtext g-aiAbs"
      style="top:64.0203%;left:30.1675%;margin-left:-19.0909%;width:38.1818%;"
    >
      <p class="g-pstyle0">Bullet hole through windshield</p>
    </div>
  </div>
  <!-- Artboard: sm -->
  <div
    id="g-airbagImage-sm"
    class="g-artboard"
    style="min-width: 510px;max-width: 659px;aspect-ratio: 0.86294416243655;"
    data-aspect-ratio="0.863"
    data-min-width="510"
    data-max-width="659"
  >
    <div
      id="g-airbagImage-sm-img"
      class="g-airbagImage-sm-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/airbagImage-sm.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai1-1"
      class="g-boxtext g-aiAbs"
      style="top:8.291%;left:37.6061%;margin-left:-11.6667%;width:23.3333%;"
    >
      <p class="g-pstyle0">Blood on airbag of Good&rsquo;s vehicle</p>
    </div>
    <div
      id="g-ai1-2"
      class="g-boxtext g-aiAbs"
      style="top:64.1286%;left:32.9992%;margin-left:-15.7843%;width:31.5686%;"
    >
      <p class="g-pstyle1">Bullet hole through windshield</p>
    </div>
  </div>
  <!-- Artboard: md -->
  <div
    id="g-airbagImage-md"
    class="g-artboard"
    style="min-width: 660px;aspect-ratio: 1.11298482293423;"
    data-aspect-ratio="1.113"
    data-min-width="660"
  >
    <div
      id="g-airbagImage-md-img"
      class="g-airbagImage-md-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/airbagImage-md.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai2-1"
      class="g-boxtext g-aiAbs"
      style="top:8.2631%;left:28.8327%;margin-left:-12.197%;width:24.3939%;"
    >
      <p class="g-pstyle0">Blood on airbag of Good&rsquo;s vehicle</p>
    </div>
    <div
      id="g-ai2-2"
      class="g-boxtext g-aiAbs"
      style="top:63.9123%;left:28.8327%;margin-left:-12.197%;width:24.3939%;"
    >
      <p class="g-pstyle0">Bullet hole through windshield</p>
    </div>
  </div>
</div>

<!-- End ai2svelte - 2026-01-08 12:30 -->

<!-- Generated by ai2svelte v0.123.1 - 2026-01-08 12:30 -->
<!-- ai file: airbagImage.ai -->
<style lang="scss">
  #g-airbagImage-box {
    container-type: inline-size;
    container-name: g-airbagImage-box;
  }
  #g-airbagImage-box,
  #g-airbagImage-box .g-artboard {
    margin: 0 auto;
  }
  #g-airbagImage-box p {
    margin: 0;
  }
  #g-airbagImage-box .g-aiAbs {
    position: absolute;
  }
  #g-airbagImage-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-airbagImage-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-airbagImage-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-airbagImage-box.g-aiPointText p {
    white-space: nowrap;
  }
  #g-airbagImage-box {
    width: 100%;
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-airbagImage-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-airbagImage-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) {
      #g-airbagImage-md {
        display: block !important;
      }
    }
  }
  #g-airbagImage-xs {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-airbagImage-xs p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 17px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(255, 255, 255);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-airbagImage-xs .g-pstyle0 {
    font-weight: 700;
    text-align: center;
  }
  #g-airbagImage-sm {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-airbagImage-sm p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 17px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(255, 255, 255);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-airbagImage-sm .g-pstyle0 {
    font-weight: 700;
    text-align: center;
  }
  #g-airbagImage-sm .g-pstyle1 {
    font-weight: 700;
    line-height: 19px;
    font-size: 16px;
    text-align: center;
  }
  #g-airbagImage-md {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-airbagImage-md p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 19px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(255, 255, 255);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-airbagImage-md .g-pstyle0 {
    font-weight: 700;
    text-align: center;
  }

  /* Custom CSS */
  .g-boxtext {
    background-color: rgba(34, 34, 34, 0.768627451);
    border-radius: 2px;
    padding: 10px 9px;
  }
</style>
